/* ============================================
   HUMAAYA WISHLIST SYSTEM v3
   Definitive fix: heart never opens product page
   ============================================ */
(function () {
  'use strict';

  var KEY = 'lm_wishlist';

  /* ---- Storage ---- */
  function getList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; } }
  function saveList(l) { localStorage.setItem(KEY, JSON.stringify(l)); }
  function isWishlisted(id) { return getList().some(function(i){ return String(i.id) === String(id); }); }
  function addItem(p) { var l=getList(); if(!l.some(function(i){return String(i.id)===String(p.id);})){l.push(p);saveList(l);} }
  function removeItem(id) { saveList(getList().filter(function(i){return String(i.id)!==String(id);})); }
  function toggleItem(p) { if(isWishlisted(p.id)){removeItem(p.id);return false;}else{addItem(p);return true;} }

  /* ---- Toast ---- */
  function showToast(msg) {
    var t=document.querySelector('.lm-wish-toast'); if(t)t.remove();
    t=document.createElement('div'); t.className='lm-wish-toast'; t.textContent=msg;
    document.body.appendChild(t);
    requestAnimationFrame(function(){requestAnimationFrame(function(){t.classList.add('lm-wish-toast--show');});});
    setTimeout(function(){t.classList.remove('lm-wish-toast--show');setTimeout(function(){t.remove();},400);},2500);
  }

  /* ---- Sync all buttons for a product ---- */
  function syncButtons(id, wishlisted) {
    var addTxt = window.lmWishStrings ? window.lmWishStrings.add : 'Add to Wishlist';
    var rmTxt  = window.lmWishStrings ? window.lmWishStrings.remove : 'Added to Wishlist ✓';
    document.querySelectorAll('.lm-wishlist-heart[data-product-id="'+id+'"]').forEach(function(btn){
      btn.classList.toggle('lm-wishlisted', wishlisted);
      btn.setAttribute('aria-pressed', wishlisted);
      btn.title = wishlisted ? rmTxt : addTxt;
    });
    document.querySelectorAll('.lm-atw-btn[data-product-id="'+id+'"]').forEach(function(btn){
      btn.classList.toggle('lm-wishlisted', wishlisted);
      var tx=btn.querySelector('.lm-atw-btn__text'); if(tx) tx.textContent = wishlisted ? rmTxt : addTxt;
    });
  }

  /* ---- Header count update ---- */
  function updateHeaderCount() {
    var count = getList().length;
    ['lm-wish-header-count','lm-wish-mobile-count'].forEach(function(id){
      var el=document.getElementById(id);
      if(el) el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    ['lm-wish-header-num','lm-wish-mobile-num'].forEach(function(id){
      var el=document.getElementById(id); if(el) el.textContent=count;
    });
    var btn=document.getElementById('lm-wishlist-header-btn');
    var mBtn=document.getElementById('lm-wishlist-mobile-btn');
    if(btn)  btn.classList.toggle('lm-has-items', count > 0);
    if(mBtn) mBtn.classList.toggle('lm-has-items', count > 0);
    document.querySelectorAll('.lm-wishlist-count').forEach(function(el){
      el.textContent=count; el.style.display=count>0?'inline-flex':'none';
    });
  }

  /* ---- Wire a single heart button ---- */
  function wireHeart(btn) {
    if (btn.dataset.lmWired) return;
    btn.dataset.lmWired = '1';

    // Set initial state
    if (isWishlisted(btn.dataset.productId)) {
      btn.classList.add('lm-wishlisted');
      btn.setAttribute('aria-pressed', 'true');
    }

    // Heart is now a sibling of .card (outside stacking context)
    // Simple click works perfectly - no capture or pointerdown tricks needed
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var id = btn.dataset.productId;
      var added = toggleItem({
        id: id,
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || '',
        variantId: btn.dataset.variantId || ''
      });

      btn.classList.remove('lm-heart-animate');
      void btn.offsetWidth;
      btn.classList.add('lm-heart-animate');

      syncButtons(id, added);
      updateHeaderCount();

      var addedMsg = window.lmWishStrings ? window.lmWishStrings.added  : 'Added to Wishlist! ❤️';
      var rmMsg    = window.lmWishStrings ? window.lmWishStrings.removed : 'Removed from Wishlist';
      showToast(added ? addedMsg : rmMsg);
    });
  }

  /* ---- Init all hearts on page ---- */
  function initHearts() {
    document.querySelectorAll('.lm-wishlist-heart').forEach(wireHeart);
  }

  /* ---- ATW button (product page) ---- */
  function initATWButtons() {
    document.querySelectorAll('.lm-atw-btn').forEach(function(btn){
      if(btn.dataset.lmWired) return;
      btn.dataset.lmWired = '1';
      var id = btn.dataset.productId;
      if(isWishlisted(id)){
        btn.classList.add('lm-wishlisted');
        var tx=btn.querySelector('.lm-atw-btn__text');
        if(tx) tx.textContent = window.lmWishStrings ? window.lmWishStrings.remove : 'Added to Wishlist ✓';
      }
      btn.addEventListener('click', function(){
        var added = toggleItem({
          id: id,
          title: btn.dataset.productTitle||'',
          url: btn.dataset.productUrl||'',
          image: btn.dataset.productImage||'',
          price: btn.dataset.productPrice||'',
          variantId: btn.dataset.variantId||''
        });
        syncButtons(id, added);
        updateHeaderCount();
        showToast(added ? (window.lmWishStrings?window.lmWishStrings.added:'Added to Wishlist! ❤️') : (window.lmWishStrings?window.lmWishStrings.removed:'Removed from Wishlist'));
      });
    });
  }

  /* ---- Wishlist page ---- */
  function renderWishlistPage() {
    var grid=document.getElementById('lm-wishlist-grid');
    var empty=document.getElementById('lm-wishlist-empty');
    if(!grid) return;
    var list=getList();
    if(empty) empty.style.display=list.length===0?'block':'none';
    grid.style.display=list.length===0?'none':'grid';
    if(list.length===0) return;
    grid.innerHTML=list.map(function(item){
      return '<div class="lm-wishlist-item" data-id="'+item.id+'">'+
        '<div class="lm-wishlist-item__img-wrap">'+
          '<a href="'+item.url+'"><img src="'+item.image+'" alt="'+item.title+'" loading="lazy"></a>'+
          '<button class="lm-wishlist-item__remove" data-id="'+item.id+'" aria-label="Remove">'+
            '<svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'+
          '</button>'+
        '</div>'+
        '<div class="lm-wishlist-item__info">'+
          '<a class="lm-wishlist-item__title" href="'+item.url+'">'+item.title+'</a>'+
          '<div class="lm-wishlist-item__price">'+item.price+'</div>'+
          '<button class="lm-wishlist-item__atc" data-variant-id="'+item.variantId+'" data-product-id="'+item.id+'">'+
            (window.lmWishStrings?window.lmWishStrings.addToCart:'Add to Cart')+
          '</button>'+
        '</div>'+
      '</div>';
    }).join('');
    grid.querySelectorAll('.lm-wishlist-item__remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        removeItem(btn.dataset.id); syncButtons(btn.dataset.id,false); renderWishlistPage(); updateHeaderCount();
        showToast(window.lmWishStrings?window.lmWishStrings.removed:'Removed from Wishlist');
      });
    });
    grid.querySelectorAll('.lm-wishlist-item__atc').forEach(function(btn){
      btn.addEventListener('click', function(){
        var vid=btn.dataset.variantId;
        if(!vid){var itm=getList().find(function(i){return String(i.id)===String(btn.dataset.productId);}); if(itm)window.location.href=itm.url; return;}
        var orig=btn.textContent; btn.disabled=true; btn.textContent='...';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
        .then(function(){btn.textContent='✓ Added!'; showToast('Added to Cart!'); setTimeout(function(){btn.disabled=false;btn.textContent=orig;},2000); refreshCartCount();})
        .catch(function(){btn.disabled=false;btn.textContent=orig;});
      });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]').forEach(function(el){el.textContent=c.item_count;});
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){});
  }

  /* ---- Drawer ---- */
  function renderDrawer() {
    var body=document.getElementById('lm-wish-drawer-body');
    var footer=document.getElementById('lm-wish-drawer-footer');
    var countEl=document.getElementById('lm-wish-drawer-count');
    if(!body) return;
    var list=getList();
    if(countEl) countEl.textContent=list.length>0?'('+list.length+')':'';
    if(footer) footer.style.display=list.length>0?'block':'none';
    if(list.length===0){
      body.innerHTML='<div class="lm-wish-drawer__empty">'+
        '<svg viewBox="0 0 24 24" fill="none"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
        '<p>Your wishlist is empty.</p><a href="/collections/all">Continue Shopping</a></div>';
      return;
    }
    body.innerHTML=list.map(function(item){
      return '<div class="lm-wish-drawer__item" data-id="'+item.id+'">'+
        '<a class="lm-wish-drawer__item-img" href="'+item.url+'"><img src="'+item.image+'" alt="'+item.title+'" loading="lazy"></a>'+
        '<div class="lm-wish-drawer__item-info">'+
          '<a class="lm-wish-drawer__item-title" href="'+item.url+'">'+item.title+'</a>'+
          '<div class="lm-wish-drawer__item-price">'+item.price+'</div>'+
          '<div class="lm-wish-drawer__item-actions">'+
            '<button class="lm-wish-drawer__atc" data-variant-id="'+item.variantId+'" data-product-id="'+item.id+'">Add to Cart</button>'+
            '<a class="lm-wish-drawer__buy" href="'+(item.variantId?'/cart/'+item.variantId+':1?checkout':item.url)+'">Buy Now</a>'+
          '</div>'+
        '</div>'+
        '<button class="lm-wish-drawer__remove" data-id="'+item.id+'" aria-label="Remove">'+
          '<svg viewBox="0 0 18 17" fill="none"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.706-.707L9.786 8.5l7.462-7.468a.5.5 0 00-.707-.707L9 7.793 1.867.5a.5.5 0 10-.704.707L8.71 8.5l-7.845 7.478z" fill="currentColor"/></svg>'+
        '</button>'+
      '</div>';
    }).join('');
    body.querySelectorAll('.lm-wish-drawer__remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        removeItem(btn.dataset.id); syncButtons(btn.dataset.id,false); renderDrawer(); updateHeaderCount();
        showToast(window.lmWishStrings?window.lmWishStrings.removed:'Removed from Wishlist');
      });
    });
    body.querySelectorAll('.lm-wish-drawer__atc').forEach(function(btn){
      btn.addEventListener('click', function(){
        var vid=btn.dataset.variantId;
        if(!vid){var itm=getList().find(function(i){return String(i.id)===String(btn.dataset.productId);}); if(itm)window.location.href=itm.url; return;}
        var orig=btn.textContent; btn.disabled=true; btn.textContent='...';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
        .then(function(){btn.textContent='✓ Added!'; showToast('Added to Cart!'); setTimeout(function(){btn.disabled=false;btn.textContent=orig;},2000); refreshCartCount();})
        .catch(function(){btn.disabled=false;btn.textContent=orig;});
      });
    });
  }

  function openDrawer() {
    var d=document.getElementById('lm-wishlist-drawer');
    var b=document.getElementById('lm-wishlist-header-btn');
    var mb=document.getElementById('lm-wishlist-mobile-btn');
    if(!d) return;
    renderDrawer();
    d.classList.add('lm-wish-drawer--open');
    d.setAttribute('aria-hidden','false');
    if(b) b.setAttribute('aria-expanded','true');
    if(mb) mb.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
  }

  function closeDrawer() {
    var d=document.getElementById('lm-wishlist-drawer');
    var b=document.getElementById('lm-wishlist-header-btn');
    var mb=document.getElementById('lm-wishlist-mobile-btn');
    if(!d) return;
    d.classList.remove('lm-wish-drawer--open');
    d.setAttribute('aria-hidden','true');
    if(b) b.setAttribute('aria-expanded','false');
    if(mb) mb.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
  }

  /* ---- MutationObserver: wire hearts added dynamically (infinite scroll etc) ---- */
  function observeNewCards() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('lm-wishlist-heart')) {
            wireHeart(node);
          }
          node.querySelectorAll && node.querySelectorAll('.lm-wishlist-heart').forEach(wireHeart);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ---- Boot ---- */
  function boot() {
    initHearts();
    initATWButtons();
    updateHeaderCount();
    renderWishlistPage();
    observeNewCards();

    var openBtn  = document.getElementById('lm-wishlist-header-btn');
    var mobileBtn= document.getElementById('lm-wishlist-mobile-btn');
    var closeBtn = document.getElementById('lm-wish-drawer-close');
    var overlay  = document.getElementById('lm-wish-overlay');
    if(openBtn)   openBtn.addEventListener('click', openDrawer);
    if(mobileBtn) mobileBtn.addEventListener('click', openDrawer);
    if(closeBtn)  closeBtn.addEventListener('click', closeDrawer);
    if(overlay)   overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });
    window.addEventListener('storage', function(e){ if(e.key===KEY) updateHeaderCount(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.LMWishlist = { getList:getList, isWishlisted:isWishlisted, add:addItem, remove:removeItem, updateCount:updateHeaderCount, renderPage:renderWishlistPage };
})();
